import type { ProductLogoMediumProps } from '../types';

/**
 * 中サイズのStorageAndFilesロゴアイコン
 */
export function ProductLogoMediumStorageAndFiles({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 672 672"
      fill="none"
      {...props}
    >
      <rect width="672" height="672" rx="100" fill="#1A2142" />
      <path
        d="M144 360C144 379.882 205.785 396 282 396C301.163 396 319.414 394.979 336 393.138V441.138C319.414 442.979 301.163 444 282 444C205.785 444 144 427.882 144 408V360Z"
        fill="white"
      />
      <path
        d="M420 336C420 340.537 416.781 344.877 410.909 348.875C408.342 348.299 405.701 348 403.029 348H372C357.57 348 345.124 356.491 339.383 368.748C321.909 370.835 302.475 372 282 372C205.785 372 144 355.882 144 336V288C144 307.882 205.785 324 282 324C358.215 324 420 307.882 420 288V336Z"
        fill="white"
      />
      <path
        d="M420 264C420 283.882 358.215 300 282 300C205.785 300 144 283.882 144 264V216C144 235.882 205.785 252 282 252C358.215 252 420 235.882 420 216V264Z"
        fill="white"
      />
      <path
        d="M282 156C358.215 156 420 172.118 420 192C420 211.882 358.215 228 282 228C205.785 228 144 211.882 144 192C144 172.118 205.785 156 282 156Z"
        fill="white"
      />
      <path
        d="M403.029 372C406.212 372 409.264 373.264 411.515 375.515L428.485 392.485C430.736 394.736 433.788 396 436.971 396H528C534.627 396 540 401.373 540 408V504C540 510.627 534.627 516 528 516H372C365.373 516 360 510.627 360 504V384C360 377.373 365.373 372 372 372H403.029Z"
        fill="#57D7D9"
      />
    </svg>
  );
}
